import axios from "axios";

export const getAllTenants = (token) => {
  return axios.get(`${process.env.REACT_APP_OPERATOR_API_GATEWAY_URL}tenants`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
};

export const createTenant = (tenantName, status, dealerIDOrToken, tokenArg) => {
  const token = tokenArg || dealerIDOrToken;
  const dealerID = tokenArg ? dealerIDOrToken : undefined;
  const payload = dealerID ? { tenantName, status, dealerID } : { tenantName, status };

  return axios.post(`${process.env.REACT_APP_OPERATOR_API_GATEWAY_URL}tenants`, payload,
    {
      headers:
        { Authorization: `Bearer ${token}` },
    }
  );
};
